import { Box, Flex, IconButton, Text } from '@chakra-ui/react';
import {
  ArrowBack as ArrowBackIcon,
  Close as CloseIcon,
} from '@mui/icons-material';

interface ProductDetailVoucherHeaderProps {
  onBack: () => void;
  onClose: () => void;
}

export const ProductDetailVoucherHeader = ({
  onBack,
  onClose,
}: ProductDetailVoucherHeaderProps) => {
  return (
    <Flex
      bg="#00003D"
      align="center"
      justify="space-between"
      px={{ base: 4, md: 6 }}
      py={{ base: 3, md: 4 }}
    >
      <Flex align="center" gap="4">
        <IconButton
          onClick={onBack}
          aria-label="Kembali"
          variant="link"
          color="white"
          icon={<ArrowBackIcon />}
          minW="auto"
          h="auto"
          p="0"
        />
        <Box w="1px" h="32px" bg="whiteAlpha.700" />
        <Text color="white" fontSize={{ base: '20px', md: '28px' }} fontWeight="600">
          Voucher
        </Text>
      </Flex>
      <IconButton
        onClick={onClose}
        aria-label="Tutup"
        variant="link"
        color="white"
        icon={<CloseIcon />}
        minW="auto"
        h="auto"
        p="0"
      />
    </Flex>
  );
};
